import { apis } from '@/services/api';

let api = apis.choferesApi;

// initial state
const state = {
    movements: []
};

// getters
const getters = {
    movements: state => state.movements
};

// actions
const actions = {
    get (store, data) {
        return api.cuentaCorriente(data).then((data) => {
            if (data && data.length) {
                data.forEach((row) => {
                    row.status = 'Consolidado';
                    if (row.viaje) {
                        if (!row.viaje.payment_success) {
                            row.status = 'Impago';
                        }
                    }
                });
                data.splice(0, 0, {
                    descripcion: 'Saldo inicial',
                    cantidad: 0,
                    saldo: data[0].saldo - data[0].cantidad,
                    status: 'Consolidado'
                });
            }
            store.commit('SET_MOVEMENTS', data);
        }).catch((error) => {
            if (error) {

            }
        });
    }
};

// mutations
const mutations = {
    SET_MOVEMENTS (state, data) {
        state.movements = data;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/currentAccount.js